import { useEffect } from "react";

const useTidio = () => {
	useEffect(() => {
		if (!document.getElementById("tidio-script")) {
			const script = document.createElement("script");
			script.src = process.env.REACT_APP_TIDIO_SRC || "";
			script.async = true;
			script.id = "tidio-script";
			document.body.appendChild(script);
		}

		// Wait for tidio launcher to appear, then inject CSS
		const observer = new MutationObserver((mutations, obs) => {
			const launcher =
				document.querySelector(".tidio-chat-launcher") ||
				document.querySelector("#tidio-chat-iframe") ||
				document.querySelector("#tidio-chat");

			if (launcher) {
				// Create a style element so these rules load AFTER the tidio script
				const styleId = "tidio-position-style";
				if (!document.getElementById(styleId)) {
					const css = `
            /* adjust values as needed */
            .tidio-chat-launcher,
            #tidio-chat-iframe,
            #tidio-chat {
              bottom: 60px !important;
            }

            /* mobile safe */
            @media (max-width: 600px) {
              .tidio-chat-launcher,
              #tidio-chat-iframe,
              #tidio-chat {
                bottom: 60px !important;
              }
            }
          `;
					const style = document.createElement("style");
					style.id = styleId;
					style.appendChild(document.createTextNode(css));
					document.head.appendChild(style);
				}

				obs.disconnect();
			}
		});

		observer.observe(document.body, { childList: true, subtree: true });

		return () => observer.disconnect();
	}, []);
};

export default useTidio;
